//
//
//
//

export default {
  name: 'Empty',
  data() {
    return {};
  },
};
